import { z } from "zod";

import { libraryProgressStates, librarySortOrders } from "./libraryFilters";

const categories = ["tv", "anime", "kdrama"] as const;
const statuses = ["airing", "upcoming", "returning", "ended", "cancelled", "unknown"] as const;

/**
 * My Lists' filter state, as it appears in the URL.
 *
 * Every field degrades to `undefined` rather than throwing: a hand-edited or
 * stale link should open the library unfiltered, not an error boundary. This is
 * the same contract the calendar and discovery search schemas hold.
 */
export const myListsSearchSchema = z.object({
  q: z.string().trim().max(120).optional().catch(undefined),
  category: z.enum(categories).optional().catch(undefined),
  status: z.enum(statuses).optional().catch(undefined),
  genre: z.string().trim().max(60).optional().catch(undefined),
  progress: z.enum(libraryProgressStates).optional().catch(undefined),
  sort: z.enum(librarySortOrders).optional().catch(undefined),
});

export type MyListsSearch = z.infer<typeof myListsSearchSchema>;
